import React from "react";
import * as Flags from "country-flag-icons/react/3x2";

interface FlagIconProps {
  countryCode?: string;
  size?: number;
  style?: React.CSSProperties;
}

const FlagIcon: React.FC<FlagIconProps> = ({ countryCode, size = 18, style }) => {
  if (!countryCode) return null;
  const Flag = (Flags as Record<string, React.FC<React.SVGProps<SVGSVGElement>>>)[
    countryCode.toUpperCase()
  ];
  if (!Flag) return null;
  return (
    <Flag
      style={{
        width: size,
        height: size * 0.75,
        borderRadius: 2,
        display: "block",
        flexShrink: 0,
        boxShadow: "0 0 0 1px rgba(0,0,0,0.08)",
        ...style,
      }}
    />
  );
};

export default FlagIcon;
